import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { getAuthToken, getAuthUser } from "./auth";
import "./TillsPage.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000";

function SuperAdminTillsPage() {
  const user = getAuthUser();
  const token = getAuthToken();

  const isSuperAdmin = user?.role === "super_admin";

const [shops, setShops] = useState([]);
const [selectedShopId, setSelectedShopId] = useState("");

  const [tills, setTills] = useState([]);
  const [shop, setShop] = useState(null);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [generatingCodeId, setGeneratingCodeId] = useState(null);

  const [newTillName, setNewTillName] = useState("");
  const [newTillCode, setNewTillCode] = useState("");

  const [activationDetails, setActivationDetails] = useState(null);
  const [managedTill, setManagedTill] = useState(null);
const [disconnectingTillId, setDisconnectingTillId] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

const loadShops = useCallback(async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/super-admin/shops`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setShops(Array.isArray(res.data) ? res.data : []);
  } catch (err) {
    console.error("Load shops error:", err);

    setError(
      err.response?.data?.error ||
        "Failed to load shops"
    );
  }
}, [token]);

const fetchTills = useCallback(async () => {
  try {
    setLoading(true);
    setError("");

    let params = {};

if (isSuperAdmin) {
  if (!selectedShopId) {
    setTills([]);
    setShop(null);
    setLoading(false);
    return;
  }

  params = {
    shop_id: selectedShopId,
  };
}

    const response = await axios.get(`${API_BASE_URL}/tills`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });

    setTills(response.data?.tills || []);
    setShop(response.data?.shop || null);
  } catch (err) {
    console.error("Load tills error:", err);

    setError(
      err.response?.data?.error ||
        "Tills could not be loaded"
    );
  } finally {
    setLoading(false);
  }
}, [token, isSuperAdmin, selectedShopId]);

useEffect(() => {
  if (isSuperAdmin) {
    loadShops();
  }
}, [isSuperAdmin, loadShops]);

useEffect(() => {
  if (isSuperAdmin && !selectedShopId) {
    setTills([]);
    setShop(null);
    return;
  }

  fetchTills();

  const timer = setInterval(() => {
    fetchTills();
  }, 30000);

  return () => clearInterval(timer);
}, [fetchTills, isSuperAdmin, selectedShopId]);

  const handleCreateTill = async (e) => {
  e.preventDefault();

  const cleanName = newTillName.trim();
  const cleanCode = newTillCode.trim().toUpperCase();

  if (isSuperAdmin && !selectedShopId) {
    setError("Please select a shop first");
    return;
  }

  if (!cleanName) {
    setError("Till name is required");
    return;
  }

  try {
    setCreating(true);
    setError("");
    setMessage("");

    const payload = {
      name: cleanName,
    };

    if (isSuperAdmin) {
      payload.shop_id = Number(selectedShopId);
    }

    if (cleanCode) {
      payload.till_code = cleanCode;
    }

    const response = await axios.post(
      `${API_BASE_URL}/tills`,
      payload,
      {
        headers,
      }
    );

    setMessage(
      response.data?.message ||
        "Till created successfully"
    );

    setNewTillName("");
    setNewTillCode("");

    await fetchTills();
  } catch (err) {
    console.error("Create till error:", err);

    setError(
      err.response?.data?.error ||
        "Till could not be created"
    );
  } finally {
    setCreating(false);
  }
};

  const handleGenerateActivationCode = async (till) => {
        if (isSuperAdmin && !selectedShopId) {
  setError("Please select a shop first");
  return;
}
    
    try {
      setGeneratingCodeId(till.id);
      setError("");
      setMessage("");
      setActivationDetails(null);

 

const payload = isSuperAdmin
  ? { shop_id: Number(selectedShopId) }
  : {};

const response = await axios.post(
  `${API_BASE_URL}/tills/${till.id}/activation-code`,
  payload,
  {
    headers,
  }
);

      setActivationDetails({
        ...response.data,
        till,
      });
    } catch (err) {
      console.error("Generate activation code error:", err);

      setError(
        err.response?.data?.error ||
          "Activation code could not be generated"
      );
    } finally {
      setGeneratingCodeId(null);
    }
  };

  const handleDisconnectTill = async (till) => {
  const confirmed = window.confirm(
    `Disconnect ${till.name} from its current computer?\n\n` +
      "The existing till installation will stop authenticating with the cloud. " +
      "You will need to generate a new activation code before another computer can use this till."
  );

  if (!confirmed) return;

  try {
    setDisconnectingTillId(till.id);
    setError("");
    setMessage("");

    if (isSuperAdmin && !selectedShopId) {
  setError("Please select a shop first");
  return;
}

const payload = isSuperAdmin
  ? { shop_id: Number(selectedShopId) }
  : {};

const response = await axios.post(
  `${API_BASE_URL}/tills/${till.id}/disconnect`,
  payload,
  {
    headers,
  }
);

    setMessage(
      response.data?.message ||
        "Till device disconnected successfully"
    );

    setManagedTill(null);

    await fetchTills();
  } catch (err) {
    console.error("Disconnect till error:", err);

    setError(
      err.response?.data?.error ||
        "Till device could not be disconnected"
    );
  } finally {
    setDisconnectingTillId(null);
  }
};

  const formatLastSeen = (value) => {
    if (!value) return "Never";

    const time = new Date(value).getTime();

    if (!Number.isFinite(time)) return "Unknown";

    const seconds = Math.max(
      0,
      Math.floor((Date.now() - time) / 1000)
    );

    if (seconds < 60) return `${seconds}s ago`;

    const minutes = Math.floor(seconds / 60);

    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);

    if (hours < 24) return `${hours}h ago`;

    return new Date(value).toLocaleString();
  };

  return (
    <div className="tills-page">
     <div className="tills-page-header super-admin-hero">
  <div>
    <h1>Till Management</h1>

    <p>
      {isSuperAdmin && !selectedShopId ? (
        "Manage tills, activation codes and connected devices across all shops."
      ) : (
        <>
          Manage checkout devices for{" "}
          <strong>{shop?.name || "this shop"}</strong>.
        </>
      )}
    </p>
  </div>

  <button
    type="button"
    className="tills-refresh-btn"
    onClick={fetchTills}
    disabled={loading || (isSuperAdmin && !selectedShopId)}
  >
    {loading ? "Refreshing..." : "Refresh"}
  </button>
</div>

      {message && (
        <div className="tills-message tills-message-success">{message}</div>
      )}

      {error && (
        <div className="tills-message tills-message-error">{error}</div>
      )}
      {isSuperAdmin && (
        <section className="tills-card">
          <div className="tills-card-header">
            <div>
              <h2>Select Shop</h2>
              <p>Select a shop to manage its tills.</p>
            </div>
          </div>

          <div className="tills-field">
            <select
              value={selectedShopId}
              onChange={(e) => {
  setSelectedShopId(e.target.value);
  setTills([]);
  setShop(null);
  setMessage("");
  setError("");
  setManagedTill(null);
  setActivationDetails(null);
}}
            >
              <option value="">Select shop</option>

              {shops.map((shop) => (
                <option key={shop.id} value={shop.id}>
                  #{shop.id} - {shop.name}
                </option>
              ))}
            </select>
          </div>
        </section>
      )}

      {(!isSuperAdmin || selectedShopId) && (
      <div className="tills-grid">
        <section className="tills-card">
          <div className="tills-card-header">
            <div>
              <h2>Create Till</h2>
              <p>Add another checkout device to this shop.</p>
            </div>
          </div>

          <form className="tills-create-form" onSubmit={handleCreateTill}>
            <div className="tills-field">
              <label htmlFor="new-till-name">Till name</label>

              <input
                id="new-till-name"
                type="text"
                placeholder="Example: Front Counter"
                value={newTillName}
                onChange={(e) => setNewTillName(e.target.value)}
              />
            </div>

            <div className="tills-field">
              <label htmlFor="new-till-code">Till code</label>

              <input
                id="new-till-code"
                type="text"
                placeholder="Optional, e.g. TILL-03"
                value={newTillCode}
                onChange={(e) => setNewTillCode(e.target.value)}
              />

              <small>
                Leave empty to generate the next code automatically.
              </small>
            </div>

            <button
              type="submit"
              className="tills-create-btn"
              disabled={
  creating ||
  loading ||
  (isSuperAdmin && !selectedShopId)
}
            >
              {creating ? "Creating..." : "Create Till"}
            </button>
          </form>
        </section>

        <section className="tills-card tills-list-card">
          <div className="tills-card-header">
            <div>
              <h2>Shop Tills</h2>
              <p>Online status refreshes every 30 seconds.</p>
            </div>

            <span className="tills-count">{tills.length}</span>
          </div>

          {loading && tills.length === 0 ? (
            <div className="tills-empty">Loading tills...</div>
          ) : tills.length === 0 ? (
            <div className="tills-empty">No tills found.</div>
          ) : (
            <div className="tills-list">
              {tills.map((till) => (
                <article key={till.id} className="till-item">
                  <div className="till-item-main">
                    <div className="till-title-row">
                      <div>
                        <h3>{till.name}</h3>
                        <span>{till.till_code}</span>
                      </div>

                      <span
                        className={`till-status ${
                          till.online
                            ? "till-status-online"
                            : "till-status-offline"
                        }`}
                      >
                        {till.online ? "Online" : "Offline"}
                      </span>
                    </div>

                    <div className="till-details-grid">
                      <div>
                        <span>Activated</span>
                        <strong>{till.activated ? "Yes" : "No"}</strong>
                      </div>

                      <div>
                        <span>Current user</span>
                        <strong>{till.current_user_id || "—"}</strong>
                      </div>

                      <div>
                        <span>Last seen</span>
                        <strong>{formatLastSeen(till.last_seen_at)}</strong>
                      </div>

                      <div>
                        <span>App version</span>
                        <strong>{till.app_version || "—"}</strong>
                      </div>
                    </div>
                  </div>

                  <div className="till-actions">
                    {till.activated ? (
                      <button
                        type="button"
                        className="till-manage-btn"
                        onClick={() => setManagedTill(till)}
                      >
                        Manage Till
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="till-activation-btn"
                        onClick={() => handleGenerateActivationCode(till)}
                        disabled={generatingCodeId === till.id}
                      >
                        {generatingCodeId === till.id
                          ? "Generating..."
                          : "Activate Till"}
                      </button>
                    )}
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </div>
      )}
      {activationDetails && (
        <div
          className="activation-modal-backdrop"
          onClick={() => setActivationDetails(null)}
        >
          <div
            className="activation-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="activation-modal-close"
              onClick={() => setActivationDetails(null)}
            >
              ×
            </button>

            <span className="activation-modal-label">Activation code</span>

            <h2>
              {activationDetails.till?.name ||
                activationDetails.till?.till_name}
            </h2>

            <div className="activation-code-value">
              {activationDetails.activation_code}
            </div>

            <p>
              Enter this code on the till computer. It expires in{" "}
              {activationDetails.expires_in_minutes || 15} minutes.
            </p>

            <button
              type="button"
              className="activation-modal-done"
              onClick={() => setActivationDetails(null)}
            >
              Done
            </button>
          </div>
        </div>
      )}
      {isSuperAdmin && !selectedShopId && (
  <div className="tills-empty">
    Please select a shop to view or create tills.
  </div>
)}
      {managedTill && (
        <div
          className="activation-modal-backdrop"
          onClick={() => setManagedTill(null)}
        >
          <div
            className="till-manage-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="activation-modal-close"
              onClick={() => setManagedTill(null)}
            >
              ×
            </button>

            <div className="till-manage-heading">
              <span>Manage Till</span>
              <h2>{managedTill.name}</h2>
              <p>{managedTill.till_code}</p>
            </div>

            <div className="till-manage-status-row">
              <span
                className={`till-status ${
                  managedTill.online
                    ? "till-status-online"
                    : "till-status-offline"
                }`}
              >
                {managedTill.online ? "Online" : "Offline"}
              </span>

              <span className="till-activated-badge">Activated</span>
            </div>

            <div className="till-manage-details">
              <div>
                <span>Current user</span>
                <strong>{managedTill.current_user_id || "No user"}</strong>
              </div>

              <div>
                <span>Last seen</span>
                <strong>{formatLastSeen(managedTill.last_seen_at)}</strong>
              </div>

              <div>
                <span>Last sync</span>
                <strong>{formatLastSeen(managedTill.last_sync_at)}</strong>
              </div>

              <div>
                <span>App version</span>
                <strong>{managedTill.app_version || "Unknown"}</strong>
              </div>

              <div className="till-device-id-row">
                <span>Device ID</span>
                <strong>{managedTill.device_id || "Not available"}</strong>
              </div>
            </div>

            <div className="till-manage-warning">
              Disconnect only when replacing the till computer, reinstalling
              DeskPOS, or moving this till to another device.
            </div>

            <div className="till-manage-actions">
              <button
                type="button"
                className="till-manage-close-btn"
                onClick={() => setManagedTill(null)}
              >
                Close
              </button>

              <button
                type="button"
                className="till-disconnect-btn"
                disabled={disconnectingTillId === managedTill.id}
                onClick={() => handleDisconnectTill(managedTill)}
              >
                {disconnectingTillId === managedTill.id
                  ? "Disconnecting..."
                  : "Disconnect Device"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuperAdminTillsPage;